<template>
    <div class="bill-item">     
        <div class="item-left">            
            <img src="../../../assets/cash.png"/>            
        </div>   
        <div class="item-right">
            <div>
                <span class="font35 color-4F">运单号：{{item.trackingNumber}}</span>                
            </div>
            <div>
                <span class="font32 color-8F">{{date}}</span>
                <span class="font37 color-orange">+{{item.commission}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            item: {
                type: Object,
                require: true
            }
        },
        data() {
            return {
                currentDate: $moment(new Date()).format('YYYY-MM-DD')
            }
        },
        computed: {
            date() {
                return this.item.createDate.indexOf(this.currentDate) !== -1 ?
                    '今天' + this.item.createDate.substring(this.item.createDate.indexOf(' '), this.item.createDate.lastIndexOf(':')) :
                    this.item.createDate.substring(0, this.item.createDate.lastIndexOf(':'))
            }
        }
    }
</script>

<style scoped lang="less">
    .bill-item {
        background-color: #fff;
        height: 2rem;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #DBDBDB;

        .item-left {
            padding: 0.29rem 0.45rem;

            img {
                display: block;
                width: 1rem;
                height: 1rem;
            }
        }

        .item-right {
            flex: 1;
            padding: 0.29rem 0.31rem 0.29rem 0.35rem;

            > div {
                height: 0.71rem;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
            }
        }
    }
</style>
